'use client';
import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';
const DoorSvg = forwardRef(
  (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      fill="currentColor"
      ref={ref}
      {...props}
    >
      <path d="M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,40H192V216H64Zm104,92a12,12,0,1,1-12-12A12,12,0,0,1,168,132Z" />
    </svg>
  )
);
type ComponentProps = Omit<SvgIconProps, 'inheritViewbox' | 'component'>;
function Component(
  props: ComponentProps,
  ref: React.ForwardedRef<SVGSVGElement>
) {
  return (
    <SvgIcon
      data-testid="DoorIcon"
      ref={ref}
      {...props}
      component={DoorSvg}
      inheritViewBox
    />
  );
}
Component.displayName = 'DoorIcon';
Component.muiName = SvgIcon.muiName;
export default React.memo(forwardRef(Component));
